import React, { Component, Fragment } from 'react';
import NibeForm from './components/NibeForm/NibeForm';
import axios from 'axios';
import './styles/nibe.scss';

export default class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            language: '',
            localizationIsReady: false,
            errorLoading: false,
           
        };
        window.__nibe = window.__nibe || {};
    }

    componentDidMount() {
        
        var link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');
        link.setAttribute('media', 'all');
        link.setAttribute('crossorigin', 'anonymous');
        link.setAttribute('href', 'https://weu-wap-3104-t-001.azurewebsites.net/static/css/main.css');
        document.getElementsByTagName('head')[0].appendChild(link);

        // Get lang by script tag
        const { language } = this.props;
       
        this.loadLocalization(language);
        window.__nibe.culture = language;
        //const script_tag = document.getElementById('nibeQuoteTool');

        //if (script_tag) {
        //    const { language } = script_tag.dataset;

        //    this.setState({
        //        language,
        //    });
        //}
    }

    componentWillUnmount() {
    }

    loadLocalization(culture) {
        var localizationJSON = sessionStorage.getItem('localization');
        let localizationData = localizationJSON ? JSON.parse(localizationJSON) : [];

        if (localizationData.length === 0 || window.__nibe.culture !== culture) {

            return axios.get(process.env.REACT_APP_API_URL + 'Translations?culture=' + encodeURI(culture),
                    {
                        headers: {
                            post: { 'Access-Control-Allow-Origin': '*' },
                            //culture: culture,
                            //Authorization: application.authorization,
                        },
                    })
                .then((response) => {
                    if (response) {
                        //Key value pair this will be done in BE later instead.
                        let keyValuePairList = [{}];
                        if (response.data && response.data.translations) {
                            response.data.translations.forEach(function(data, index) {
                                keyValuePairList[data.path] = data.value;
                            });
                        }

                        window.__nibe.translation = keyValuePairList;
                        sessionStorage.setItem('localization', JSON.stringify(keyValuePairList));
                        this.setState({ localizationIsReady: true });
                    }
                }).catch(error => {
                    if (culture !== "en-GB") {
                        this.loadLocalization("en-GB");
                    } else {
                        this.setState({ errorLoading: true, localizationIsReady: true });
                    }
                    
                    //return Promise.reject(error.response)
                });
        } else {
            window.__nibe.translation = localizationData;
            this.setState({ localizationIsReady: true });
        }
    }

    render() {
        let { language, config, siteId } = this.props;
        const { localizationIsReady, errorLoading } = this.state;

        if (errorLoading) {
            language = "en-GB";
        }

        return (

            <Fragment>
                {
                    localizationIsReady ? (
                        <div className="nibe-quote__form" >
                            <NibeForm  {...{ language, config, siteId }} />
                        </div >
                    )
                        :
                        (
                            <div className="nibe-quote__form-loader"><div className="loader"></div></div>
                        )
                }
            </Fragment>
        );
    }
}
